// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DwkGmrGm5Wuz1B {
  display: flex;
  flex-flow: row;
  flex-wrap: wrap;
}
.RkKG4gELdB8xUd {
  display: flex;
  justify-content: center;
}
.P6CMa9f9g_lIfU {
  flex: 1 1 auto;
  min-height: calc(100vh - 80px);
  padding-bottom: 32px;
  background-color: var(--ds-background-accent-gray-subtlest, #f1f2f4);
}
.RtJJEEP7VbZm5J {
  display: flex;
  justify-content: center;
  padding: 32px;
}
.vJh6ohx6LXOmfN {
  font-style: italic;
}
.rSrD7BvXP1fpZV {
  flex-grow: 1;
  min-width: 320px;
  max-width: 800px;
  padding: 32px;
  border: 1px solid var(--ds-border, #091e4224);
  border-radius: 4px;
  background-color: var(--ds-surface, #ffffff);
}
.qykRKiGxi9ZQZ3 {
  display: flex;
  align-items: center;
  justify-content: center;
}
._9feGfacExWRJd {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--ds-border, #091e4224);
}
._9feGfacExWRJd .IgUTOp1WAp3snt {
  margin: 12px 0 0;
}
.VPcbmxfyBwJa0q {
  padding-top: 16px;
  border-top: 1px solid var(--ds-border, #091e4224);
}
.VPcbmxfyBwJa0q button {
  margin-left: 8px;
}
.pQP3da8z5UNx9o {
  display: flex;
  justify-content: flex-end;
}
@media only screen and (max-width: 900px) {
  .rSrD7BvXP1fpZV {
    padding: 16px;
  }
}
.MZF2ctT2Ve0HKN {
  margin: 16px 0;
}
.LBKXHICwKABe6v {
  max-width: none;
  height: 200px;
  border: 1px solid var(--ds-border, #091e4224);
  border-radius: 4px;
  background-color: var(--background-accent-gray-subtlest);
  font-family: var(--ds-font-family-code, ui-monospace, 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Courier, monospace);
  white-space: pre;
  resize: none;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"flexRowWrap": `DwkGmrGm5Wuz1B`,
	"flexAndCenter": `RkKG4gELdB8xUd`,
	"body": `P6CMa9f9g_lIfU`,
	"navigationAndContent": `RtJJEEP7VbZm5J`,
	"learnMoreSubtle": `vJh6ohx6LXOmfN`,
	"content": `rSrD7BvXP1fpZV`,
	"spinnerContainer": `qykRKiGxi9ZQZ3`,
	"header": `_9feGfacExWRJd`,
	"title": `IgUTOp1WAp3snt`,
	"footer": `VPcbmxfyBwJa0q`,
	"formFooter": `pQP3da8z5UNx9o`,
	"enableButtonContainer": `MZF2ctT2Ve0HKN`,
	"enableButtonSnippet": `LBKXHICwKABe6v`
};
export default ___CSS_LOADER_EXPORT___;
